import { StarsRating } from "./StarsRating";
export { StarsRating };
